import router from '@/router'
import { AuthService } from '../../services/auth.service'

export default {
  namespaced: true,
  state: {
    accessTokenExpDate: '',
    token: '',
  },
  actions: {
    logout({ commit }, is403 = false) {
      commit('LOGOUT', is403)
    },
  },
  mutations: {
    SET_ATOKEN_EXP_DATE(state, expDate) {
      state.accessTokenExpDate = expDate
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    async LOGOUT(state, is403) {
      const ssoConfigRes = await AuthService.getSsoConfig()
      const ssoConfig = ssoConfigRes.data ?? {}
      await AuthService.makeLogout()
        .finally(s => {
          state.user = null
          state.token = null
          localStorage.removeItem('userData')
          localStorage.removeItem('token')
          localStorage.removeItem('dataPermission')
          return s
        })
        .finally(s => {
          const isSSO = localStorage.getItem('isSSO')
          const sessionID = localStorage.getItem('sessionSSO')
          if (is403) router.push({ name: '403' })
          else if (isSSO == 1) {
            window.location.href = `${ssoConfig.domain}/logout?portal=${ssoConfig.portal}&sessionId=${sessionID}&logoutAll=false`
          } else {
            router.push('/login?nosso=1')
          }
        })
    },
  },
}
